<template>
  <div class="userList electricityBill">
    <!-- 充值管理 rechargeManage-->
    <div class="content">
      <div class="search">
        <el-form ref="form" :model="form" label-width="87px" style="display: flex;width: auto;">
          <el-form-item label="业主姓名">
            <el-input v-model="form.ownerName" placeholder="请输入用姓名" class="el-input-mysmall"></el-input>
          </el-form-item>
          <el-form-item label="业主编号">
            <el-input v-model="form.rfid" placeholder="请输入业主编号" class="el-input-mysmall"></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="form.mobile" placeholder="请输入手机号" class="el-input-mysmall"></el-input>
          </el-form-item>
          <el-form-item label="地址">
            <el-input v-model="form.address" placeholder="请输入地址" class="el-input-mysmall"></el-input>
          </el-form-item>
        </el-form>
        <el-button type="primary" size="mini" @click="search" style="margin-left: 10px;">查询</el-button>
        <!-- <el-button type="primary" size="mini" @click="exportList" :loading="loadingBtn">导出</el-button> -->
      </div>

      <div class="userList-table" :style="{'height':heights+'px'}">
        <el-table :data="tableData2" v-loading="loading" stripe style="width: 100%" :max-height="heights - 20" border>
          <template slot="empty">
            <span class="noData">
              <img src="../../assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column type="index" width="90" label="序号" fixed>
          </el-table-column>
          <el-table-column prop="用户名" label="业主姓名" min-width="137" />
          <el-table-column prop="用户编号" label="业主编号" min-width="137" />
          <el-table-column prop="手机号" label="手机号" min-width="137" />
          <el-table-column prop="用户地址" label="地址" min-width="137" />
          <el-table-column prop="余额" label="余额" min-width="97" />

          <el-table-column label="操作" min-width="77" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="getDataList(scope.row)">充值</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="divider-line"></div>
      <div class="paging">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          background :page-sizes="[15, 25, 35, 45, 55]" :page-size="15" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>

      <el-dialog :visible.sync="dialogTableVisible" width="1100px" v-dialogDrag :close-on-click-modal='false'>
        <rechargeDetail :formData="formData" style="margin-top:-50px"></rechargeDetail>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogTableVisible = false">确 定</el-button>
        </div>
      </el-dialog>

      <downloadTable ref="downloadTable"></downloadTable>
    </div>


  </div>
</template>

<script>
  import {findOperatingRecord,findRecordType} from "../../api/zhongshanMeter";
  import resourcesStore from '@/cache/resourcesStore.js'
  import rechargeDetail from './rechargeDetail.vue'
  import downloadTable from '@/components/module/downloadTable/downloadTable.vue'
  import request from "@/api/http.js";
  export default {
    components: {
      rechargeDetail,
      downloadTable
    },
    data () {
      return {
        formData: {},
        dialogTableVisible: false,
        loadingBtn: false,
        children_total: 0,
        children_params: {},//请求参数
        detail_status: false,//详情弹窗
        childrenList: [],//详情数据
        loading2: false,
        tableData3: [{
          a: '1234567',
          b: '500.00',
          c: '200.00',
          d: '200.00',
          e: '200.00',
          f: '2.00',
        },{
          a: '1234567',
          b: '500.00',
          c: '200.00',
          d: '200.00',
          e: '200.00',
          f: '2.00',
        },{
          a: '1234567',
          b: '500.00',
          c: '200.00',
          d: '200.00',
          e: '200.00',
          f: '2.00',
        },{
          a: '1234567',
          b: '500.00',
          c: '200.00',
          d: '200.00',
          e: '200.00',
          f: '2.00',
        },],
        tableData2: [],
        heji: {},//合计
        heights: document.getElementById('app').clientHeight-300,//屏幕高度 - 导航栏高度
        // 操作类型
        recordTypeList: [],
        //加载中
        loading: false,
        form: {
          queryType: 'DAY'
        },
        searchflag: false,//是否搜索过
        //查询
        total: 0,
        currentPage: 1,
        currentSize: 15,
        tableData: [],//表格数据
        datetimeValue: [new Date('2023/6/1').getTime(),new Date().getTime()],
        startDate: '',//日期
        endDate: new Date().getTime(),//日期
        pickerOptions: {
          disabledDate (time) {
            return time.getTime()>Date.now();
          }
        },
      };
    },

    mounted () {
      this.search() //获取列表数据

    },
    methods: {


      //搜索
      search () {
        this.searchflag=true;//已搜索
        var params={
          'pageIndex': this.currentPage,
          'pageSize': this.currentSize,
          address: this.form.address,
          ownerName: this.form.ownerName,
          rfid: this.form.rfid,
          mobile: this.form.mobile,
          unitId: this.$store.unitStore.getters.getNowUnit.id
        }
        this.loading=true;
        request({url: "/revenueManagement/getCashDepositLimit.do",method: "get",params}).then(res => {
          this.loading=false;
          console.log(res,1);
          if(res.code==200) {
            this.tableData2=res.data.dataList
            this.total=res.data.total
          }
        })
      },
      // 充值
      getDataList (v) {
        this.dialogTableVisible=true;
        this.formData=v;
        // var data={
        //   "targetId": v,
        //   "type": "MeterReading",
        //   "detailType": "Recharge_CashPay",
        //   "amount": "1",
        //   "password": "c4ca4238a0b923820dcc509a6f75849b",
        //   "memo": ""
        // }
        // request({url: "/revenueManagement/rechargeJY",method: "post",data}).then(res => {

        //   if(res.success) {


        //   }
        // })
      },



      //下载表格excel
      exportList () {
        let time=new Date();
        let year=time.getFullYear();
        let month=time.getMonth()+1;
        let day=time.getDate();

        const tHeader=[];
        this.$refs.downloadTable.export2Excel(tHeader,this.tableData,year+"-"+month+"-"+day+'-电费账单','.userList-table')


      },
      openDownloadFile (urlObj,saveName) {
        var openDownload=function(href,fileName) {
          var downloadElement=document.createElement('a');
          downloadElement.target="_blank";
          downloadElement.href=href;
          downloadElement.download=fileName||""; // HTML5新增的属性，指定保存文件名，可以不要后缀
          document.body.appendChild(downloadElement);
          downloadElement.click(); // 点击下载
          document.body.removeChild(downloadElement); // 下载完成移除元素
        }

        if(typeof urlObj=='object'&&urlObj instanceof Blob) {
          if(window.navigator&&window.navigator.msSaveOrOpenBlob) {
            //针对于IE浏览器的处理, 因部分IE浏览器不支持createObjectURL
            window.navigator.msSaveOrOpenBlob(urlObj,saveName);
          } else {
            var url=window.URL.createObjectURL(urlObj); // 创建blob地址
            openDownload(url,saveName);
            window.URL.revokeObjectURL(url); // 释放掉blob对象创建的地址
          }
        } else {
          openDownload(urlObj,saveName);
        }
      },
      //分页功能
      newgetNowPageDataList (v) {
        // 当前页显示
        this.search()

      },
      handleSizeChange (val) {
        this.currentSize=val;
        this.newgetNowPageDataList();
      },
      handleCurrentChange (val) {
        this.currentPage=val;
        this.newgetNowPageDataList();
      }


    },
    filters: {
      // 转换时间戳
      "date_format": function(value) { //value就是插值的数据
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
        let strDate=Y+M+D+h+m+s;
        return strDate
      },
    }
  };
</script>
<style>
  .electricityBill .tableNest th {
    background-color: #f5f8fa !important;
    color: #999 !important;
  }

  .electricityBill .el-table__expanded-cell {
    background-color: #f5f8fa !important;
  }

  .electricityBill .el-table__expanded-cell {
    padding: 5px;
    padding-right: 0;
    padding-bottom: 0;
    padding-left: 44px;
  }
</style>
<style lang="scss" scoped>
  .box {
    display: flex;
    border: 1px solid #E6E6E6;
    justify-content: space-between;
    margin: 20px;
    height: 100px;
    box-sizing: border-box;
    padding: 20px 0;
  }

  .box .li {
    flex: 1;
    display: flex;
    justify-content: center;
    border-left: 1px solid #E6E6E6;
  }

  .box .li img {
    margin-right: 15px;
  }

  .box .li .t {
    font-size: 24px;
    font-weight: bold;
    color: #1A1A1A;
  }

  .box .li .b {
    font-size: 16px;
    font-weight: 400;
    color: #999;
  }

  .box .li:nth-child(1) {
    border-left: none;
  }

  .userList {
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: center;

    .content {
      width: 100%;
      height: 100%;
      background-color: #fff;
      overflow: hidden;

      .userList-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        // height: 50px;
        margin: 0px 20px;
        padding: 20px 0px 12px 0px;
        border-bottom: 2px solid #E6E6E6;

        .user-left {
          display: flex;
          align-items: center;

          span {
            display: inline-block;
            height: 50px;
            line-height: 50px;
            margin-right: 40px;
            cursor: pointer;
            color: #999999;

            &.active {
              color: #359eff;
              font-weight: bold;
              border-bottom: 2px solid #359eff;
            }
          }
        }
      }


      .search {
        display: flex;
        align-items: center;
        margin: 12px 0px 20px 0px;
        position: relative;
        left: -3px;

        .el-form-item {
          margin-bottom: 0px;
        }

        .el-date-editor.el-input,
        .el-date-editor.el-input__inner {
          width: 350px;
        }
      }

      .userList-table {
        margin: 0px 20px;

        .el-table th {
          border-right: 1px solid #E6E6E6;
        }

        .el-table th.is-leaf {
          border-bottom: 0px;
        }

        .status {
          width: 8px;
          height: 8px;
          display: inline-block;
          border-radius: 50%;
          position: relative;
          top: -1px;
        }





      }

      .paging {
        display: flex;
        justify-content: flex-end;
        margin-top: 15px;
        margin-right: 15px;
      }

    }

    .el-form-item__label {
      padding: 0px;
    }



  }
</style>